/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Upload_Media_FileInputs */

const en_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to upload media file`)
};

const fr_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du téléversement du fichier média`)
};

const de_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendatei konnte nicht hochgeladen werden`)
};

const it_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il file multimediale`)
};

const ru_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить медиафайл.`)
};

const es_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el archivo multimedia`)
};

const zh_cn2_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体文件上传失败`)
};

const ja_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルのアップロードに失敗しました`)
};

const hi_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया फ़ाइल अपलोड करने में विफल`)
};

const pt_pt2_failed_to_upload_media_file = /** @type {(inputs: Failed_To_Upload_Media_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar o arquivo de mídia`)
};

/**
* | output |
* | --- |
* | "Failed to upload media file" |
*
* @param {Failed_To_Upload_Media_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_upload_media_file = /** @type {((inputs?: Failed_To_Upload_Media_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Upload_Media_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_upload_media_file(inputs)
	if (locale === "de") return de_failed_to_upload_media_file(inputs)
	if (locale === "it") return it_failed_to_upload_media_file(inputs)
	if (locale === "ru") return ru_failed_to_upload_media_file(inputs)
	if (locale === "es") return es_failed_to_upload_media_file(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_upload_media_file(inputs)
	if (locale === "ja") return ja_failed_to_upload_media_file(inputs)
	if (locale === "hi") return hi_failed_to_upload_media_file(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_upload_media_file(inputs)
	return en_failed_to_upload_media_file(inputs)
});